<template>
  <div class="header">
    <div class="logo" @click="logoClicked">
      <router-link :to="{ name: 'home' }" exact>
        <img src="../assets/images/studio308-logo.png" id="logo" alt="image" class="dark">
      </router-link>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: 'page-header',
  data () {
    return {
      title: ''
    }
  },
  methods: {
    logoClicked () {
      this.$emit('logo-clicked')
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss

  .header
    width: 77.5%
    margin: 0 15% 0 7.5%
    padding-bottom: 80px

    @media screen and (min-width: $break-small)
      //width: 30%

    //@media screen and (min-width: $break-medium)
    //  width: 80%
    //  margin: 0 15% 0 10%

    @media screen and (min-width: $break-large)
      width: 70%
      margin: 0 auto

    > .logo
      width: 37%
      float: left

      @media screen and (min-width: $break-small)
        width: 30%

      @media screen and (min-width: $break-medium)
        width: 25%

      @media screen and (min-width: $break-large)
        width: 20%

    > .content
      width: 52%
      float: right

      @media screen and (min-width: $break-small)
        width: 64%

      @media screen and (min-width: $break-medium)
        width: 69%

      @media screen and (min-width: $break-large)
        width: 73%

  .header
    margin-top: 10%

  #logo
    width: 100%
    margin: 0 auto
    background-color: $mainColor
  
</style>



// WEBPACK FOOTER //
// PageHeader.vue?94cae60e